import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import KineticHero from "@/components/KineticHero";
import EditorialMarquee from "@/components/EditorialMarquee";
import NumberedManifesto from "@/components/NumberedManifesto";
import ScheduleGrid from "@/components/ScheduleGrid";
import Pricing from "@/components/Pricing";
import CoachSpotlight from "@/components/CoachSpotlight";
import VideoReel from "@/components/VideoReel";
import PhotographyGallery from "@/components/PhotographyGallery";
import FooterContact from "@/components/FooterContact";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1.05,
      touchMultiplier: 1.4,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, []);

  return (
    <div className="App grain" data-testid="app-root">
      <Navbar />
      <main>
        <KineticHero />
        <EditorialMarquee />
        <NumberedManifesto />
        <ScheduleGrid />
        <Pricing />
        <CoachSpotlight />
        <VideoReel />
        <PhotographyGallery />
        <FooterContact />
      </main>
    </div>
  );
}

export default App;
